import React, { useEffect, useState } from 'react'

import { useAuth } from '../../contexts/Auth'
import { useLocation } from 'react-router-dom'

const ImpersonateLogin = () => {
    const { API_BASE_URL } = window['runtimeConfig']
    const { authenticate } = useAuth()
    const location = useLocation()
    const [error, setError] = useState(null)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const ticket = params.get('ticket')

        if (!ticket) {
            setError('No impersonation ticket provided.')
            return
        }

        fetch(`${API_BASE_URL}/impersonate/redeem/${ticket}/`, { method: 'POST' })
            .then(res => res.json())
            .then(data => {
                if (data.token) {
                    authenticate(data.token, '/')
                } else {
                    setError(data.error || 'Failed to redeem ticket.')
                }
            })
            .catch(() => setError('Could not reach the server.'))
    }, [])

    if (error) {
        return <p style={{ padding: '2rem', color: 'red' }}>{error}</p>
    }

    return <p style={{ padding: '2rem' }}>Signing in…</p>
}

export default ImpersonateLogin
